export function BadgeCheckSolid({ width = 16 }: { width?: number }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      width={width}
      fill="none"
    >
      <path
        d="M256 0C292.8 0 324.8 20.7 340.9 51.1 373.8 41 411 48.9 437 75s34 63.3 23.9 96.2C491.3 187.2 512 219.2 512 256s-20.7 68.8-51.1 84.9C471 373.8 463 411 437 437s-63.3 34-96.2 23.9C324.8 491.3 292.8 512 256 512s-68.8-20.7-84.9-51.1C138.2 471 101 463 75 437s-34-63.3-23.9-96.2C20.7 324.8 0 292.8 0 256s20.7-68.8 51.1-84.9C41 138.2 48.9 101 75 75s63.3-34 96.2-23.9C187.2 20.7 219.2 0 256 0zm57.4 169.9L227.8 287.6c-19.3-20-33.7-34.9-43.2-44.7l-34.5 33.3c6.2 6.4 27.2 28.1 63.1 65.3l19.8 20.6 16.8-23.1 102.4-140.8 14.1-19.4-38.8-28.2-14.1 19.4z"
        fill="currentColor"
      />
    </svg>
  );
}
